import styled from "styled-components";
import { CenterFlexColumn, FlexRow } from "styles/layout";
import { Theme } from "theme";

// todo - styling shared with Tournament equivalent, consolidate?
export const TourContainer = styled(FlexRow)`
  padding: 4px ${Theme.smallPanelPadding};
  line-height: 100%;
`;

export const TourTrigrams = styled(CenterFlexColumn)`
  row-gap: 4px;
  width: 50px;
  font-size: 11.5pt;
`;

export const TourLogoContainer = styled.div`
  width: 75px;
  height: 75px;
  margin-left: auto;
`;
